export const floorPlanListColumn = [
    {
        Header: 'Id',
        accessor: 'id',
    },
    {
        Header: 'Floor Name',
        accessor: 'floorName',
    },
    {
        Header: 'Number Of Room',
        accessor: 'numberOfRoom',
    },
    {
        Header: 'Start Room Number',
        accessor: 'startRoomNumber',
    },
    {
        Header: 'Actions',
        accessor: 'actions',
    }
]

export const floorPlanListTableData = [
    {
        "id": "1101",
        "floorName": "Fouteenth Floor",
        "numberOfRoom": "5",
        "startRoomNumber": "1400"
    },
    {
        "id": "1102",
        "floorName": "Seventh Floor",
        "numberOfRoom": "5",
        "startRoomNumber": "700"
    },
    {
        "id": "1103",
        "floorName": "Thirteenth Floor",
        "numberOfRoom": "5",
        "startRoomNumber": "1300"
    },
    {
        "id": "1104",
        "floorName": "Eleventh Floor",
        "numberOfRoom": "5",
        "startRoomNumber": "1100"
    },
    {
        "id": "1105",
        "floorName": "Nineth Floor",
        "numberOfRoom": "5",
        "startRoomNumber": "900"
    }
]